import { render } from "./DeleteProductCarrierModal.vue?vue&type=template&id=8ce5b6bc"
import script from "./DeleteProductCarrierModal.vue?vue&type=script&lang=js"
export * from "./DeleteProductCarrierModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__